import { Scenario } from '../../types';
import { steps } from './steps';
import { registerScenario } from '../registry';

export const createElectionScenario: Scenario = {
  id: 'createElection',
  title: 'Créer une campagne',
  description: 'Apprenez à créer une campagne de vote',
  module: 'votez',
  type: 'contextual',  // Uses fixed bottom drawer instead of floating popovers
  steps,
  defaultStepOrder: [
    'intro',
    'click-new-campaign',
    'enter-title',
    'configure-dates',
    'save-campaign',
    'dashboard-tabs',
    'dashboard-stats-cards',
    'dashboard-participation',
    'go-to-config',
    'config-sub-tabs',
    'config-general',
    'config-apparence',
    'go-to-bulletin',
    'question-types',
    'choose-question-type', // Decision step: election or proposition
    // Branch steps will be inserted dynamically based on user choice
    'votants-explanation',
    'publish-explanation',
    'conclusion',
  ],
  branches: {
    'choose-question-type': [
      {
        id: 'proposition',
        label: 'Proposition (Oui/Non)',
        description: 'Créer une question simple où les votants répondent Oui ou Non',
        nextSteps: ['add-proposition', 'proposition-form', 'proposition-created'],
      },
      {
        id: 'election',
        label: 'Élection (Candidats)',
        description: 'Créer une élection avec des candidats à choisir',
        nextSteps: ['add-election', 'election-form', 'election-created'],
      },
    ],
  },
};

// Register on import
registerScenario(createElectionScenario);

export default createElectionScenario;
